<!-- Figma "Onboarding Component - N01 Nova Overlay" (node 33:8935), minus the header: Nova's own
     header (without Voice Chat) and its close stay where they are. -->
<section class="nova-first-use" aria-labelledby="nova-first-use-heading-0">
  <div class="nova-first-use__eyebrow">
    <svg-icon src="assets/icons/icon-super-stars-mono.svg"></svg-icon>
    <span>Getting started</span>
  </div>

  <!-- One continuous scrollable view: the four sections are not steps. -->
  <div class="nova-first-use__scroll" tabindex="0" role="group" aria-label="How Nova works">
    <ng-container *ngFor="let section of copy.sections; let i = index">
      <div class="nova-first-use__divider" *ngIf="i > 0" aria-hidden="true"></div>
      <h3
        class="nova-first-use__heading"
        [class.nova-first-use__heading--title]="i === 0"
        [id]="'nova-first-use-heading-' + i"
        [attr.tabindex]="i === 0 ? -1 : null"
      >
        {{ section.heading }}
      </h3>
      <p class="nova-first-use__body">{{ section.body }}</p>
    </ng-container>
  </div>

  <p class="nova-first-use__help">
    {{ copy.helpLine.before }}<a routerLink="/help" (click)="closed.emit()">{{ copy.helpLine.link }}</a
    >{{ copy.helpLine.after }}
  </p>
</section>
